import { FOLLOWUP_REQUIRED, NOFOLLOWUP_REQUIRED, NEW_LINE, RESPONDED_WITH } from '../../constants'
import moment from 'moment'

export const buildGmisRequest = (fields, { abbrevation }, flowType) => {
  const gmisRequest = {}
  gmisRequest.question = fields.question.value
  gmisRequest.product = fields.product.value
  gmisRequest.Specialty = ''
  gmisRequest.FacilitatorType = ''
  gmisRequest.isMSL = ''

  gmisRequest.Facilitator = {}
  gmisRequest.Facilitator.AV_External_Id__c = ''
  gmisRequest.Facilitator.FirstName = ''
  gmisRequest.Facilitator.LastName = ''
  gmisRequest.Facilitator.BillingCountry = ''
  gmisRequest.Facilitator.AV_Territory_Number__c = ''

  gmisRequest.Facilitator.personEmail = ''

  gmisRequest.Requestor = {}
  gmisRequest.Requestor.FirstName = fields.firstname.value
  gmisRequest.Requestor.LastName = fields.lastname.value
  gmisRequest.Requestor.BillingStreet = fields.street.value
  gmisRequest.Requestor.BillingCity = fields.city.value
  gmisRequest.Requestor.BillingState = fields.state.value
  gmisRequest.Requestor.BillingPostalCode = fields.postalCode.value
  gmisRequest.Requestor.BillingCountry = abbrevation
  gmisRequest.Requestor.Phone = fields.phone.value
  gmisRequest.Requestor.AV_Institution_Company__c = fields.affiliation.value
  gmisRequest.Requestor.AV_HCP_License_Number__c = fields.hcpLicenseNumber.value
  gmisRequest.Requestor.AV_PhoneExtn__c = fields.extn.value

  gmisRequest.Requestor.AV_Veeva_Org_id__c = ''
  gmisRequest.Requestor.AV_Veeva_CRM_ID__c = ''
  gmisRequest.Requestor.AV_Gender__c = ''
  gmisRequest.Requestor.AV_Specialty__c = fields.medicalSpeciality.value
  gmisRequest.Requestor.AV_Account_Type__c = fields.userType.value
  gmisRequest.Requestor.Salutation = fields.title.value || 'Dear'

  gmisRequest.medicalInquiry = {}
  gmisRequest.medicalInquiry.AV_Form_of_response__c = fields.deliveryMethod.value
  gmisRequest.medicalInquiry.AV_Veeva_MIR_id__c = ''
  gmisRequest.medicalInquiry.AV_Indication__c = fields.indicator.value
  gmisRequest.medicalInquiry.AV_Requestor_Country__c = abbrevation
  gmisRequest.medicalInquiry.AV_Requestor_Email__c = fields.email.value
  gmisRequest.medicalInquiry.AV_Veeva_MIR_Number__c = ''
  gmisRequest.medicalInquiry.AV_Response_Due_Date__c = _setDueDate(fields.responseDeadline.displayValue, fields.deliveryMethod.value)
  if (flowType !== 'MI_PORTAL_REQUEST') {
    gmisRequest.medicalInquiry.AV_Source__c = flowType === 'CONFERENCE' ? 'Conference' : 'MedInfo Booth'
    gmisRequest.medicalInquiry.AV_Source_Detail__c = fields.conference.value === '' ? 'Conference Name' : fields.conference.value
  }
  if (flowType === 'SCIBOOTH') {
    _updateNotesField(fields, gmisRequest)
  }

  return gmisRequest
}

const _setDueDate = (deadline, deliveryMethod) => {
  if (deadline) {
    return deadline
  }
  const turnaroundDays = deliveryMethod === 'Mail' ? 15 : 5
  const dueDate = moment(new Date())
  dueDate.add(turnaroundDays, 'days')
  return dueDate.format('YYYY-MM-DD')
}

const _updateNotesField = ({ respondedWith, followup }, gmisRequest) => {
  gmisRequest.AV_Request_Notes = RESPONDED_WITH + respondedWith.value
  if (followup.value) {
    gmisRequest.question = gmisRequest.question + NEW_LINE + FOLLOWUP_REQUIRED
  } else {
    gmisRequest.question = gmisRequest.question + NEW_LINE + NOFOLLOWUP_REQUIRED
    gmisRequest.medicalInquiry.AV_Form_of_response__c = 'Phone'
  }
}



// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/BuildGmisRequest.js